import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _createGroupRequest = { group: '_group' };
var _createGroupResponse = { group: '_group' };
var _deleteGroupRequest = {};
var _deleteGroupResponse = { group: '_group' };
var _getGroupBySlugRequest = {};
var _getGroupBySlugResponse = { group: '_group' };
var _getGroupRequest = {};
var _getGroupResponse = { group: '_group' };
var _group = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    recentActivityDate: 'google.protobuf.Timestamp',
    details: '_groupDetails',
};
var _groupDetails = {
    logoPosition: '_position',
    mobileLogoPosition: '_position',
};
var _groupWithRelationship = { group: '_group' };
var _listGroupsRequest = {};
var _listGroupsResponse = { groups: '_group' };
var _position = { x: 'FLOAT', y: 'FLOAT' };
var _queryGroupsRequest = {};
var _queryGroupsResponse = { groups: '_group' };
var _queryGroupsWithRelationshipsRequest = {};
var _queryGroupsWithRelationshipsResponse = {
    groupWithRelationship: '_groupWithRelationship',
};
var _updateGroupRequest = { group: '_group' };
var _updateGroupResponse = { group: '_group' };
function resolveWixSocialGroupsApiV2GroupsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/social-groups-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Creates a group.
 * >**Notes:**
 * > + The site owners may not allow members to create groups.
 * > + Specify a `creatorId` to set the group's creator.
 * > + The group's creator will automatically become an admin.
 */
export function createGroup(payload) {
    return function __createGroup(_a) {
        var host = _a.host;
        var toJSON = serializer(_createGroupRequest, {
            _group: _group,
            _groupDetails: _groupDetails,
            _position: _position,
        }).toJSON;
        var fromJSON = serializer(_createGroupResponse, {
            _group: _group,
            _groupDetails: _groupDetails,
            _position: _position,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Updates a group.
 * >**Note:**
 * > + Only admins can update a group.
 * > + When `group.privacyLevel` is updated from `PRIVATE` to `PUBLIC`, all pending group join requests are automatically approved.
 * > + When `group.privacyLevel` is updated from `PRIVATE` to `SECRET`, all pending group join requests are automatically rejected.
 */
export function updateGroup(payload) {
    return function __updateGroup(_a) {
        var host = _a.host;
        var toJSON = serializer(_updateGroupRequest, {
            _group: _group,
            _groupDetails: _groupDetails,
            _position: _position,
        }).toJSON;
        var fromJSON = serializer(_updateGroupResponse, {
            _group: _group,
            _groupDetails: _groupDetails,
            _position: _position,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'PATCH',
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/{group.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Hides a group from the Group List or cancels group request.
 * >**Notes:**
 * > + Only admins can delete a group.
 * > + The group will no longer be visible in the live site or the Wix business manager.
 * > + It is not possible to restore the group via the [Update Group](https://dev.wix.com/api/rest/wix-groups/groups/group/update-group) endpoint into the live site.
 * > + It is still possible to retrieve the group via the [Get Group](https://dev.wix.com/api/rest/wix-groups/groups/group/get-group), [List Groups](https://dev.wix.com/api/rest/wix-groups/groups/group/list-groups) and [Query Groups](https://dev.wix.com/api/rest/wix-groups/groups/group/query-groups) endpoints.
 */
export function deleteGroup(payload) {
    return function __deleteGroup(_a) {
        var host = _a.host;
        var toJSON = serializer(_deleteGroupRequest, {}).toJSON;
        var fromJSON = serializer(_deleteGroupResponse, {
            _group: _group,
            _groupDetails: _groupDetails,
            _position: _position,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/{groupId}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Retrieves a group. */
export function getGroup(payload) {
    return function __getGroup(_a) {
        var host = _a.host;
        var toJSON = serializer(_getGroupRequest, {}).toJSON;
        var fromJSON = serializer(_getGroupResponse, {
            _group: _group,
            _groupDetails: _groupDetails,
            _position: _position,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/{groupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Retrieves a group by slug. */
export function getGroupBySlug(payload) {
    return function __getGroupBySlug(_a) {
        var host = _a.host;
        var toJSON = serializer(_getGroupBySlugRequest, {}).toJSON;
        var fromJSON = serializer(_getGroupBySlugResponse, {
            _group: _group,
            _groupDetails: _groupDetails,
            _position: _position,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/slugs/{slug}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/** Retrieves up to 100 groups. */
export function listGroups(payload) {
    return function __listGroups(_a) {
        var host = _a.host;
        var toJSON = serializer(_listGroupsRequest, {}).toJSON;
        var fromJSON = serializer(_listGroupsResponse, {
            _group: _group,
            _groupDetails: _groupDetails,
            _position: _position,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Retrieves up to 100 groups, given the provided paging, filtering, and sorting.
 *
 * Supported fields for filtering:
 * - `title`
 *
 * Supported fields for sorting:
 * - `title`
 * - `createdDate`
 * - `membersCount`
 * - `recentActivityDate`
 */
export function queryGroups(payload) {
    return function __queryGroups(_a) {
        var host = _a.host;
        var toJSON = serializer(_queryGroupsRequest, {}).toJSON;
        var fromJSON = serializer(_queryGroupsResponse, {
            _group: _group,
            _groupDetails: _groupDetails,
            _position: _position,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Deprecated: use GroupMembers.QueryMemberships.
 * Query groups with relationship.
 * In response requester can see list of groups which is visible to him/her with requested site member relationships.
 */
export function queryGroupsWithRelationships(payload) {
    return function __queryGroupsWithRelationships(_a) {
        var host = _a.host;
        var toJSON = serializer(_queryGroupsWithRelationshipsRequest, {}).toJSON;
        var fromJSON = serializer(_queryGroupsWithRelationshipsResponse, {
            _group: _group,
            _groupDetails: _groupDetails,
            _groupWithRelationship: _groupWithRelationship,
            _position: _position,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2GroupsServiceUrl({
                protoPath: '/v2/groups-with-relationships/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map